import React from 'react';
import { CountdownBanner } from './CountdownBanner';
import { Check } from 'lucide-react';
export function PricingSection() {
  const totalPrice = 19.9;
  const totalPriceFormatted = totalPrice.toFixed(2).replace('.', ',');
  const realValue = 290;
  const discount = 93;
  const checkoutUrl = 'https://italia.digitalpack.shop/cart/54234270269715:1';
  return <section id="pricing" className="w-full bg-bg-main py-20 sm:py-32 px-4 sm:px-6 relative overflow-hidden" data-id="element-141">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none opacity-30 blur-3xl" style={{
      background: 'radial-gradient(circle, rgba(37,99,235,0.1) 0%, transparent 70%)'
    }} data-id="element-142"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-143">
        <div className="bg-white rounded-3xl sm:rounded-[2.5rem] border border-border-light shadow-2xl px-5 py-10 sm:p-16 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-144">
          <div className="absolute -top-4 sm:-top-5 left-1/2 -translate-x-1/2 bg-secondary text-white font-black text-xs sm:text-base px-6 sm:px-8 py-2 sm:py-2.5 rounded-full whitespace-nowrap shadow-lg border border-white/20 uppercase tracking-wider" data-id="element-145">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <h2 className="text-2xl sm:text-4xl font-black text-text-main text-center mt-4 mb-8 sm:mb-12 tracking-tight" data-id="element-146">
            Il Kit Completo Educazione Civica
          </h2>

          <div className="space-y-4 sm:space-y-6 mb-8 sm:mb-12 text-base sm:text-lg" data-id="element-147">
            <div className="flex items-center justify-between text-text-main font-medium border-b border-border-light pb-3" data-id="element-148">
              <div className="flex items-center gap-3" data-id="element-149">
                <Check className="w-5 h-5 text-primary" data-id="element-150" />
                <span data-id="element-151">6 Volumi Professionali</span>
              </div>
              <span className="text-text-sec line-through" data-id="element-152">€ 127</span>
            </div>
            <div className="flex items-center justify-between text-text-main font-medium border-b border-border-light pb-3" data-id="element-153">
              <div className="flex items-center gap-3" data-id="element-154">
                <Check className="w-5 h-5 text-primary" data-id="element-155" />
                <span data-id="element-156">100 Dibattiti Guidati</span>
              </div>
              <span className="text-text-sec line-through" data-id="element-157">€ 47</span>
            </div>
            <div className="flex items-center justify-between text-text-main font-medium border-b border-border-light pb-3" data-id="element-158">
              <div className="flex items-center gap-3" data-id="element-159">
                <Check className="w-5 h-5 text-primary" data-id="element-160" />
                <span data-id="element-161">50 Compiti di Realtà</span>
              </div>
              <span className="text-text-sec line-through" data-id="element-162">€ 37</span>
            </div>
            <div className="flex items-center justify-between text-text-main font-medium border-b border-border-light pb-3" data-id="element-163">
              <div className="flex items-center gap-3" data-id="element-164">
                <Check className="w-5 h-5 text-primary" data-id="element-165" />
                <span data-id="element-166">Programmazione Annuale</span>
              </div>
              <span className="text-text-sec line-through" data-id="element-167">€ 27</span>
            </div>
            <div className="flex items-center justify-between text-text-main font-medium border-b border-border-light pb-3" data-id="element-168">
              <div className="flex items-center gap-3" data-id="element-169">
                <Check className="w-5 h-5 text-primary" data-id="element-170" />
                <span data-id="element-171">Kit IA e Bonus Extra</span>
              </div>
              <span className="text-text-sec line-through" data-id="element-172">€ 52</span>
            </div>

            <div className="flex justify-between text-text-main font-black pt-2 text-lg sm:text-2xl" data-id="element-173">
              <span data-id="element-174">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-175">€ 290,00</span>
            </div>
          </div>

          <CountdownBanner data-id="element-176" />

          <div className="text-center mb-8 sm:mb-10 bg-bg-dark border border-border-light py-8 sm:py-12 rounded-2xl relative overflow-hidden" data-id="element-177">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-178">
              <span className="text-text-sec line-through text-xl sm:text-3xl font-medium" data-id="element-179">
                € 290,00
              </span>
              <span className="bg-badge-red text-white font-black text-xs sm:text-sm px-3 py-1 rounded-full" data-id="element-180">
                {discount}% OFF
              </span>
            </div>

            <div className="font-black text-6xl sm:text-8xl tracking-tighter text-text-main leading-none" data-id="element-181">
              € 19
            </div>
          </div>

          <a href={checkoutUrl} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-lg sm:text-2xl py-4 sm:py-6 rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_10px_40px_rgba(16,185,129,0.3)] border border-white/20 mb-6" data-id="element-182">
            🚀 SÌ! VOGLIO EDUCAZIONE CIVICA PRONTA
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-text-sec text-sm font-medium" data-id="element-183">
            <span className="flex items-center gap-2" data-id="element-184">
              <span className="text-lg" data-id="element-185">⚡</span> Accesso Immediato
            </span>
            <span className="flex items-center gap-2" data-id="element-186">
              <span className="text-lg" data-id="element-187">💳</span> Pagamento Unico
            </span>
            <span className="flex items-center gap-2" data-id="element-188">
              <span className="text-lg" data-id="element-189">🛡️</span> Garanzia 7 Giorni
            </span>
          </div>
        </div>
      </div>
    </section>;
}